import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'content-list-item',
  templateUrl: './content-list-item.component.html',
  styleUrls: ['./content-list-item.component.css'],
  host: {'class': 'flex-horizontal'}
})
export class ContentListItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
